import React, { Component } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col,
    Label
} from "reactstrap";
import styled from "styled-components";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { CropFree as QRIcon } from "@material-ui/icons";
import { PictureAsPdf as PDFIcon } from "@material-ui/icons";
import { Link } from "react-router-dom";
import {
    Button,
    List,
    ListItem,
    ListItemText,
    IconButton,
    TableRow,
    Typography,
    Card,
    Table,
    TableBody,
    Grid
} from "@material-ui/core";
import ReactToPrint from "react-to-print";
import "./vehicle.css";
import {
    StyledHeader
} from "../../../styles";
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;
class ViewAttachedFiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            qrModal: false,
        };
    }
    handleQrModal = () => {
        this.setState({ qrModal: true });
    };
    render() {
        const { isOpen, close, vehicle, allInfo } = this.props;
        let info_history = ""
        allInfo && allInfo.map((info) => {
            return (
                <>
                    {info.profile.machine_reg === vehicle.machine_reg ?
                        info_history = info.history
                        :
                        ""
                    }
                </>
            )
        })
        return (
            <>
                <Modal isOpen={isOpen}>
                    <ModalHeader>
                        View Vehicle Details
                        <IconButton
                            style={{
                                border: "1px solid #0188cc",
                                color: "#0188cc",
                                marginRight: "10px",
                                marginLeft: "190px",
                            }}
                            onClick={() => {
                                this.handleQrModal();
                            }}
                        >
                            <QRIcon />
                        </IconButton>
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <img
                                style={{
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    display: "block",
                                    width: 220,
                                    height: 200,
                                    borderRadius: "12px",
                                    border: "2px solid #0188cc",
                                }}
                                src={
                                    vehicle.photo_url !== ""
                                        ? vehicle.photo_url
                                        : noImg
                                }
                                alt={"icon"}
                            />
                        </div>
                        <br />
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "large", marginLeft: "123px" }}>
                                Vehicle Nickname:&nbsp;
                            </b>
                            <p style={{ display: "inline", fontSize: "large" }}>
                                {vehicle.machine_nickname || "N/A"}
                            </p>
                        </div>
                        <br />
                        {/* <ModalRow> */}
                        <h5 style={{ color: "#0188cc" }}>Vehicle Details:</h5>
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>
                                Vehicle Description:
                            </b>
                            <p style={{ display: "inline", fontSize: "small" }}>
                                {vehicle.machine_desc || "N/A"}
                            </p>
                        </div>
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Vehicle Registration:
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.machine_reg || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Service Period(In Weeks):
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.service_period || "N/A"}
                                </p>
                            </div>
                        </div>
                        {/* </ModalRow> */}
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    CRW/NCT/MOT Expiry:
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.machine_nct_expiry || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>
                                    Tax Date of Expiry:
                                </b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.machine_tax_expiry || "N/A"}
                                </p>
                            </div>
                        </div>
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>Last Service:</b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.last_service_date || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>Insurance Expiry:</b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.machine_insurance_expiry || "N/A"}
                                </p>
                            </div>
                        </div>
                        <br />
                        <div className="par halfwidth">
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>Category:</b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.machine_category || "N/A"}
                                </p>
                            </div>
                            <div className="chi">
                                <b style={{ fontSize: "small" }}>Thorough Inspection(In Weeks):</b>
                                <p
                                    style={{
                                        display: "inline",
                                        fontSize: "small",
                                    }}
                                >
                                    {vehicle.thorough_inspection_service_period || "N/A"}
                                </p>
                            </div>
                        </div>
                        <br />
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Inspection Template:</b>
                            <p
                                style={{
                                    display: "inline",
                                    fontSize: "small",
                                }}
                            >
                                {vehicle.inspection_template || "N/A"}
                            </p>
                        </div>
                        <br />
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Area's:</b>
                            {vehicle.areas &&
                                vehicle.areas.map((area) => {
                                    return (
                                        <p
                                            style={{
                                                display: "inline",
                                                fontSize: "small",
                                            }}
                                        >
                                            {area + "   " || "N/A"}
                                        </p>
                                    );
                                })}
                        </div>
                        <br />
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Department's:</b>
                            {vehicle.departments &&
                                vehicle.departments.map((department) => {
                                    return (
                                        <p
                                            style={{
                                                display: "inline",
                                                fontSize: "small",
                                            }}
                                        >
                                            {department + "   " || "N/A"}
                                        </p>
                                    );
                                })}
                        </div>
                        <br />
                        <div
                            className="fullwidth"
                            style={{ background: "#f3f2f1" }}
                        >
                            <b style={{ fontSize: "small" }}>Comments:</b>
                            <p
                                style={{
                                    display: "inline",
                                    fontSize: "small",
                                }}
                            >
                                {vehicle.machine_comments || "N/A"}
                            </p>
                        </div>
                        <br />
                        <div>
                            <List style={{ background: "#eee" }}>
                                <div style={{ clear: "both", border: "2px solid #0188cc", borderRadius: "6px", marginLeft: "5px", marginTop: "10px" }}>
                                    <h1 style={{
                                        backgroundColor: "#0188cc",
                                        textAlign: "center",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        color: "white",
                                        fontSize: "22px"
                                    }}>
                                        Thorough Inspection Records
                                    </h1>
                                </div>
                                {vehicle.inspection_records && vehicle.inspection_records
                                    .map((e, index) => {
                                        return (
                                            <StyledListItem
                                                borderColor={"#0188cc"}
                                                style={{
                                                    root: {
                                                        borderLeft: "#0188cc",
                                                    },
                                                }}
                                            >
                                                <Grid container spacing={4}>
                                                    <Grid item sm={12} md={12} lg={6} xl={6}>
                                                        <Typography
                                                            variant="body2"
                                                            style={{ paddingLeft: 24 }}
                                                        >
                                                            <b>Inspector Name: </b>
                                                            {e.inspector_name}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item sm={12} md={12} lg={6} xl={6}>

                                                        <Typography
                                                            variant="body2"
                                                            style={{ paddingLeft: 24 }}
                                                        >
                                                            <b>Timestamp: </b>
                                                            {e.timestamp}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </StyledListItem>
                                        );
                                    })}
                            </List>
                        </div>
                        <br />

                        <div>
                            <List style={{ background: "#eee" }}>
                                <div style={{ clear: "both", border: "2px solid #0188cc", borderRadius: "6px", marginLeft: "5px", marginTop: "10px" }}>
                                    <h1 style={{
                                        backgroundColor: "#0188cc",
                                        textAlign: "center",
                                        padding: "4px",
                                        fontWeight: "bold",
                                        color: "white",
                                        fontSize: "22px"
                                    }}>
                                        Repair/Service Records
                                    </h1>
                                </div>
                                {vehicle.service_data && vehicle.service_data
                                    .map((e, index) => {
                                        return (
                                            <StyledListItem
                                                borderColor={"#0188cc"}
                                                style={{
                                                    root: {
                                                        borderLeft: "#0188cc",
                                                    },
                                                }}
                                            >
                                                <Grid container spacing={4}>
                                                    <Grid item sm={12} md={12} lg={12} xl={12}>
                                                        <Typography
                                                            variant="body2"
                                                            style={{ paddingLeft: 24, wordBreak:"break-word", width:"104%" }}
                                                        >
                                                            <b>Service Carried Out By: </b>
                                                            {e.service_carried_by}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item sm={12} md={12} lg={12} xl={12}>

                                                        <Typography
                                                            variant="body2"
                                                            style={{ paddingLeft: 24, width:"104%" }}
                                                        >
                                                            <b>Timestamp: </b>
                                                            {e.timestamp}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                <br/>
                                                    <div>
                                                        {e.attached_files && (
                                                            // <List>
                                                            <>
                                                                {e.attached_files.map((f) => {
                                                                    return (
                                                                        <>
                                                                            <Link
                                                                                to={`/pdf-viewer/file_manager/machine_documents/${f.file_id}`}
                                                                            >
                                                                                <IconButton
                                                                                    style={{
                                                                                        border:
                                                                                            "1px solid black",
                                                                                        color: "black",
                                                                                        marginRight: "10px",
                                                                                        marginLeft: "190px",
                                                                                    }}
                                                                                >
                                                                                    <PDFIcon />
                                                                                </IconButton>
                                                                            </Link>
                                                                        </>
                                                                    );
                                                                })}
                                                            </>
                                                            
                                                        )}
                                                        </div>
                                            </StyledListItem>
                                        );
                                    })}
                            </List>
                        </div>
                        <br />
                        <h5 style={{ color: "#0188cc" }}>Machine Photos:</h5>
                        <div>
                            {vehicle.attached_photos &&
                                vehicle.attached_photos.map((photo, i) => {
                                    return (
                                        <img
                                            src={
                                                photo.photo_url !== ""
                                                    ? photo.photo_url
                                                    : noImg
                                            }
                                            alt=""
                                            style={{
                                                width: 100,
                                                height: 100,
                                                padding: "10px",
                                                borderRadius: "22px",
                                                marginLeft: "11px",
                                                border: "2px solid #0188cc",
                                            }}
                                        />
                                    );
                                })}
                        </div>
                        <br />
                        <h5 style={{ color: "#0188cc" }}>Attached Files:</h5>
                        {vehicle.attached_files && (
                            <List>
                                {vehicle.attached_files.map((e) => {
                                    return (
                                        <>
                                            <Link
                                                to={`/pdf-viewer/file_manager/machine_documents/${e.file_id}`}
                                            >
                                                <IconButton
                                                    style={{
                                                        border:
                                                            "1px solid black",
                                                        color: "black",
                                                        marginRight: "10px",
                                                        marginLeft: "190px",
                                                    }}
                                                >
                                                    <PDFIcon />
                                                </IconButton>
                                                <ListItem
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary={e.file}
                                                    />
                                                </ListItem>
                                            </Link>
                                        </>
                                    );
                                })}
                            </List>
                        )}
                        <br />
                        {info_history && info_history.length !== 0 ?
                            <div>
                                <Card>
                                    <StyledHeader style={{ backgroundColor: "#0188CC" }}>
                                        <Typography variant="headline" style={{ paddingLeft: "144px", fontWeigth: "bold", color: "white" }}>
                                            Cleaning History
                                            </Typography>
                                    </StyledHeader>
                                </Card>
                            </div>
                            :
                            ""
                        }
                        <div>
                            <Table>
                                <TableBody>
                                    {info_history && Object.values(info_history).map((history, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <div
                                                    className="icon-text-container"
                                                    style={{
                                                        borderWidth: "medium",
                                                        // border: "7px solid #0188cc",
                                                        borderRadius: "9px",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    <div className="float-left icon-container">
                                                        <img
                                                            style={{
                                                                borderRadius: "12px",
                                                                width: "161px",
                                                                height: "140px",
                                                                marginTop: "16px",
                                                                marginLeft: "108px",
                                                                marginBottom: "10px",
                                                                border:
                                                                    "2px solid #0188cc"
                                                            }}
                                                            src={
                                                                history.photo_url ==
                                                                    null
                                                                    ? noImg
                                                                    : history.photo_url
                                                            }
                                                            alt="proof"
                                                        />
                                                    </div>
                                                    <div className="float-left text-container">
                                                        <h5
                                                            style={{
                                                                border:
                                                                    "2px solid #0188cc",
                                                                borderRadius: "12px",
                                                                padding: "7px",
                                                                width: "400px"
                                                            }}
                                                        >
                                                            <b>Last Cleaned:</b>{" "}
                                                            <span className="subHeading">
                                                                {
                                                                    history.timestamp
                                                                }
                                                            </span>
                                                        </h5>
                                                        <h5
                                                            style={{
                                                                border:
                                                                    "2px solid #0188cc",
                                                                borderRadius: "12px",
                                                                padding: "7px",
                                                                width: "400px"
                                                            }}
                                                        >
                                                            <b>Last Cleaned By:</b>{" "}
                                                            <span className="subHeading">
                                                                {
                                                                    history.user_name
                                                                }
                                                            </span>
                                                        </h5>

                                                    </div>


                                                    <div className="clear"></div>
                                                </div>
                                            </TableRow>
                                        )
                                    }
                                    )}

                                </TableBody>
                            </Table>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="contained" onClick={() => close()}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.qrModal}>
                    <ModalHeader>View QR Code</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Label>QR Code</Label>
                                <p>
                                    <TableRow
                                        ref={(el) => (this.componentRef = el)}
                                    >
                                        {vehicle.qr_code_url ? (
                                            <img
                                                alt="profile avatar"
                                                src={vehicle.qr_code_url}
                                                style={{
                                                    height: 220,
                                                    width: 200,
                                                }}
                                            />
                                        ) : (
                                                "No QR Code Available"
                                            )}
                                    </TableRow>
                                </p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <ReactToPrint
                            trigger={() => (
                                <Button variant="contained" color="primary">
                                    Print
                                </Button>
                            )}
                            content={() => this.componentRef}
                        />
                        <Button
                            variant="contained"
                            onClick={() => this.setState({ qrModal: false })}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
export default ViewAttachedFiles;